/* THIS IS A GENERATED FILE. PLEASE DO NOT MODIFY!! */
import * as Types from '../../../../../types/dashboard-core-gqlTypes.generated.d';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type PortalBusServicingCyclesForDealQueryVariablesGQLType = Types.Exact<{
  implementationId: Types.Scalars['UUID'];
}>;


export type PortalBusServicingCyclesForDealQueryGQLType = (
  { __typename?: 'Query' }
  & { portalBusServicingCycles: Array<(
    { __typename?: 'PortalBusServicingCycleListItem' }
    & Pick<Types.PortalBusServicingCycleListItemGQLType, 'id' | 'implementationId' | 'creditFacilityId' | 'organizationName' | 'implementationName' | 'creditFacilityName' | 'reportingPeriod' | 'cycleStatus' | 'approvalStatus' | 'certificateStatus' | 'reconcileStatus' | 'tapeRowCount' | 'tapeTotalPrincipal' | 'tapeReceivedAt' | 'msrReceivedAt' | 'certificateIssuedAt' | 'certificateSignedAt' | 'tapeDueAt' | 'certificateDueAt'>
  )> }
);

export type PortalBusServicingCycleQueryVariablesGQLType = Types.Exact<{
  servicingCycleId: Types.Scalars['UUID'];
}>;


export type PortalBusServicingCycleQueryGQLType = (
  { __typename?: 'Query' }
  & { portalBusServicingCycle?: Types.Maybe<(
    { __typename?: 'PortalBusServicingCycle' }
    & Pick<Types.PortalBusServicingCycleGQLType, 'id' | 'organizationName' | 'implementationName' | 'creditFacilityName' | 'reportingPeriod' | 'cycleStatus' | 'approvalStatus' | 'reconcileStatus' | 'tapeReceivedAt' | 'tapeRowCount' | 'tapeTotalPrincipal' | 'msrReceivedAt' | 'certificateStatus' | 'certificateIssuedAt' | 'certificateSignedAt' | 'certificateDownloadUrl' | 'tapeDueAt' | 'certificateDueAt' | 'pipelineRunId'>
    & { reconcileResult?: Types.Maybe<(
      { __typename?: 'PortalBusReconcileResult' }
      & Pick<Types.PortalBusReconcileResultGQLType, 'status' | 'reportingPeriod' | 'provenance'>
      & { controlTotals: (
        { __typename?: 'PortalBusReconcileControlTotals' }
        & Pick<Types.PortalBusReconcileControlTotalsGQLType, 'loanCount' | 'totalPrincipal'>
      ), msrValues?: Types.Maybe<(
        { __typename?: 'PortalBusReconcileMsrValues' }
        & Pick<Types.PortalBusReconcileMsrValuesGQLType, 'collectionPeriodEnding' | 'beginningPoolBalance' | 'endingPoolBalance' | 'endingPoolBalanceFooting' | 'servicingFee'>
      )>, checks: Array<(
        { __typename?: 'PortalBusReconcileCheck' }
        & Pick<Types.PortalBusReconcileCheckGQLType, 'name' | 'status' | 'detail'>
      )> }
    )> }
  )> }
);


export const PortalBusServicingCyclesForDealDocumentGQLType = gql`
    query PortalBusServicingCyclesForDeal($implementationId: UUID!) {
  portalBusServicingCycles(implementationId: $implementationId) {
    id
    implementationId
    creditFacilityId
    organizationName
    implementationName
    creditFacilityName
    reportingPeriod
    cycleStatus
    approvalStatus
    certificateStatus
    reconcileStatus
    tapeRowCount
    tapeTotalPrincipal
    tapeReceivedAt
    msrReceivedAt
    certificateIssuedAt
    certificateSignedAt
    tapeDueAt
    certificateDueAt
  }
}
    `;

/**
 * __usePortalBusServicingCyclesForDealQuery__
 *
 * To run a query within a React component, call `usePortalBusServicingCyclesForDealQuery` and pass it any options that fit your needs.
 * When your component renders, `usePortalBusServicingCyclesForDealQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePortalBusServicingCyclesForDealQuery({
 *   variables: {
 *      implementationId: // value for 'implementationId'
 *   },
 * });
 */
export function usePortalBusServicingCyclesForDealQuery(baseOptions: Apollo.QueryHookOptions<PortalBusServicingCyclesForDealQueryGQLType, PortalBusServicingCyclesForDealQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PortalBusServicingCyclesForDealQueryGQLType, PortalBusServicingCyclesForDealQueryVariablesGQLType>(PortalBusServicingCyclesForDealDocumentGQLType, options);
      }
export function usePortalBusServicingCyclesForDealLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<PortalBusServicingCyclesForDealQueryGQLType, PortalBusServicingCyclesForDealQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PortalBusServicingCyclesForDealQueryGQLType, PortalBusServicingCyclesForDealQueryVariablesGQLType>(PortalBusServicingCyclesForDealDocumentGQLType, options);
        }
export type PortalBusServicingCyclesForDealQueryHookResult = ReturnType<typeof usePortalBusServicingCyclesForDealQuery>;
export type PortalBusServicingCyclesForDealLazyQueryGQLTypeHookResult = ReturnType<typeof usePortalBusServicingCyclesForDealLazyQueryGQLType>;
export type PortalBusServicingCyclesForDealQueryResultGQLType = Apollo.QueryResult<PortalBusServicingCyclesForDealQueryGQLType, PortalBusServicingCyclesForDealQueryVariablesGQLType>;
export const PortalBusServicingCycleDocumentGQLType = gql`
    query PortalBusServicingCycle($servicingCycleId: UUID!) {
  portalBusServicingCycle(servicingCycleId: $servicingCycleId) {
    id
    organizationName
    implementationName
    creditFacilityName
    reportingPeriod
    cycleStatus
    approvalStatus
    reconcileStatus
    tapeReceivedAt
    tapeRowCount
    tapeTotalPrincipal
    msrReceivedAt
    certificateStatus
    certificateIssuedAt
    certificateSignedAt
    certificateDownloadUrl
    tapeDueAt
    certificateDueAt
    pipelineRunId
    reconcileResult {
      status
      reportingPeriod
      provenance
      controlTotals {
        loanCount
        totalPrincipal
      }
      msrValues {
        collectionPeriodEnding
        beginningPoolBalance
        endingPoolBalance
        endingPoolBalanceFooting
        servicingFee
      }
      checks {
        name
        status
        detail
      }
    }
  }
}
    `;

/**
 * __usePortalBusServicingCycleQuery__
 *
 * To run a query within a React component, call `usePortalBusServicingCycleQuery` and pass it any options that fit your needs.
 * When your component renders, `usePortalBusServicingCycleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePortalBusServicingCycleQuery({
 *   variables: {
 *      servicingCycleId: // value for 'servicingCycleId'
 *   },
 * });
 */
export function usePortalBusServicingCycleQuery(baseOptions: Apollo.QueryHookOptions<PortalBusServicingCycleQueryGQLType, PortalBusServicingCycleQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PortalBusServicingCycleQueryGQLType, PortalBusServicingCycleQueryVariablesGQLType>(PortalBusServicingCycleDocumentGQLType, options);
      }
export function usePortalBusServicingCycleLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<PortalBusServicingCycleQueryGQLType, PortalBusServicingCycleQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PortalBusServicingCycleQueryGQLType, PortalBusServicingCycleQueryVariablesGQLType>(PortalBusServicingCycleDocumentGQLType, options);
        }
export type PortalBusServicingCycleQueryHookResult = ReturnType<typeof usePortalBusServicingCycleQuery>;
export type PortalBusServicingCycleLazyQueryGQLTypeHookResult = ReturnType<typeof usePortalBusServicingCycleLazyQueryGQLType>;
export type PortalBusServicingCycleQueryResultGQLType = Apollo.QueryResult<PortalBusServicingCycleQueryGQLType, PortalBusServicingCycleQueryVariablesGQLType>;